function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 0C4.22386 0 4 0.223858 4 0.5V2.5C4 3.32843 3.32843 4 2.5 4H0.5C0.223858 4 0 4.22386 0 4.5C0 4.77614 0.223858 5 0.5 5H2.5C3.88071 5 5 3.88071 5 2.5V0.5C5 0.223858 4.77614 0 4.5 0ZM0 11.5C0 11.7761 0.223858 12 0.5 12H2.5C3.32843 12 4 12.6716 4 13.5V15.5C4 15.7761 4.22386 16 4.5 16C4.77614 16 5 15.7761 5 15.5V13.5C5 12.1193 3.88071 11 2.5 11H0.5C0.223858 11 0 11.2239 0 11.5ZM19.5 4C19.7761 4 20 4.22386 20 4.5C20 4.77614 19.7761 5 19.5 5H17.5C16.1193 5 15 3.88071 15 2.5V0.5C15 0.223858 15.2239 0 15.5 0C15.7761 0 16 0.223858 16 0.5V2.5C16 3.32843 16.6716 4 17.5 4H19.5ZM15.5 16C15.7761 16 16 15.7761 16 15.5V13.5C16 12.6716 16.6716 12 17.5 12H19.5C19.7761 12 20 11.7761 20 11.5C20 11.2239 19.7761 11 19.5 11H17.5C16.1193 11 15 12.1193 15 13.5V15.5C15 15.7761 15.2239 16 15.5 16Z",
  fill: "white"
});

function SvgFullscreenActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenActive);
export default __webpack_public_path__ + "static/media/fullscreen-active.b42a6657.svg";
export { ForwardRef as ReactComponent };